<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/warehouse/page"
        getKey="rows" :columns="columns">
      <template #cangkuleixing="scope">
        <span v-if="scope.row.type===1">{{$t('chengpincang')}}</span>
        <span v-if="scope.row.type===2">{{$t('cailiaocang')}}</span>
        <span v-if="scope.row.type===3">{{$t('xianbiancang')}}</span>
      </template>
    </yi_curd_table>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_wms_purchase_receipt_check_warehouse_code',
  components: {
  },
  data() {
    return {
      columns: [ {
        label: 'cangkubianma',
        prop: 'code',
        width: 150,
      }, {
        label: 'cangkumingcheng',
        prop: 'name',
        width: 130,
      }, {
        label: 'cangkuleixing',
        prop: 'type',
        type: 'dictionary',
        key: 'WAREHOUSE_TYPE',
        width: 180,
      }, {
        label: 'dizhi',
        prop: 'address',
        // width: 130,
      },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130,
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 130,
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        // orderBy: 'createTime desc,triggerTime asc',
      }
      this.yt.SELECT_URL = "/web/basic/warehouse/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.get(1);
    }, 300)
  },

  methods: {

  }
};
</script>
